export default __webpack_public_path__ + "static/media/bin.7b5bbeb8.svg";